import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BatchRequirementService } from '@services/bathupdaterequirement.service';
import { CollaboratorService } from '@services/collaborator.service';
import { LoadingService } from '@services/loading.service';
import { RequirementTypesService } from '@services/requerimenttypes.service';
import { UsersService } from '@services/users.service';
import { ResponseObjectAPI } from 'src/app/models/responseObjectAPI';
import { RequirementService } from 'src/app/services/requirement.service';

@Component({
    selector: 'batch-collaborator-requirement-dialog',
    templateUrl: './batch-collaborator-requirement-dialog.component.html',
    styleUrls: ['./batch-collaborator-requirement-dialog.component.scss'],
    standalone: false
})


export class BatchCollaboratorRequirementDialogComponent implements OnInit {

  returning = false;
  form = new FormGroup({
		commentArea: new FormControl('')
  });

  @Input() requirementIds;
  @Output() returned = new EventEmitter();
  @Input() userId: null;
  customfieldsRequirementType;
  visibilityId: number;
  collaboratorLoading: boolean = false;
  formCollaborator: FormGroup

  constructor(
    public activeModal: NgbActiveModal,
    public requirementService: RequirementService,
    public requirementTypesService:RequirementTypesService,
    private batchRequirementService:BatchRequirementService,
    private _loading: LoadingService,
    private collaboratorService: CollaboratorService,
    public usersService: UsersService,
		private formBuilder: FormBuilder

    ) {

      this.formCollaborator = this.formBuilder.group({
        'requirementid': [''],
        'userid': ['', Validators.required],
        'reason': ['']
      })

    }

    isValidate: boolean = false;
    actionid:number;
    users:[]
    usersSuscribed: Array<any>;

    async ngOnInit() {

      const body = {
        requirementids: this.requirementIds
      };

      this.usersService.getUsers().subscribe((response:any) => {
        this.usersSuscribed =response.result;
      });
    }


  onSubmit() {
		let collaborator = this.formCollaborator.value
    this._loading.reloadStart(null,this._loading.blockUIList);
    const body = {
       requirementids: this.requirementIds,
       userid: collaborator.userid,
       reason: collaborator.reason
    };
    this.batchRequirementService.setCollaborator(body).subscribe((resp: ResponseObjectAPI) => {
      this.returned.emit(true);
    });

  }



}
